import {removeScrollbarOffset, addScrollbarOffset} from './scrollbar';

let filters = [];

let cards = $('.projects__item-container');

// для высоты колонок
function heightCol() {
	let heightColumns = [];

	$('.filter').find('.filter__column-wrap').each((i, e) => {
		heightColumns.push($(e).height());

		$('.filter__column').css('min-height', Math.max.apply(Math.max, heightColumns) + 41);
	});
}

let heightColTimeout = setTimeout(() => {
	heightCol();
}, 100);

if ($(window).width() > 1025) {
	$(window).on('resize', () => {
		clearTimeout(heightColTimeout);

		heightColTimeout = setTimeout(() => {
			heightCol();
		}, 100);
	});
}

// показываем фильтр
$('.js-menu-filter').on('click', (e) => {
	$('.filter').fadeToggle().toggleClass('is-active');
	$('body').toggleClass('filter-open');

	// опрделяем какой из кликов сейчас был
	// чтобы правильно определить scrollbar
	if ($(e.currentTarget).hasClass('is-active')) {
		removeScrollbarOffset();
		$(e.currentTarget).removeClass('is-active');
	} else {
		addScrollbarOffset();
		$('.filter__container').scrollTop(0);
		$(e.currentTarget).addClass('is-active');
	}

	if ($(window).width() > 1025) {
		heightCol();
	}
});

$(document).on('keydown', (e) => {
	if (e.keyCode === 27 && $('.js-menu-filter').hasClass('is-active')) {
		$('.filter').fadeToggle().toggleClass('is-active');
		$('body').toggleClass('filter-open');
		removeScrollbarOffset();
		$('.js-menu-filter').removeClass('is-active');

		if ($(window).width() > 1025) {
			heightCol();
		}
	}
});

// скрываем фильтр, отображаем доступные карточки
$('.js-filter-button').on('click', () => {
	if (!$('body').hasClass('main-page')) {
		location.href = '/';
	}

	$('.js-menu-filter').removeClass('is-active');
	$('.filter').fadeOut().removeClass('is-active');
	$('.header__hamburger').removeClass('is-active');
	$('body').removeClass('filter-open');
	removeScrollbarOffset();

	new TimelineMax()
		.staggerFrom($('.js-projects-sort').filter(':visible'), 0.4, {
			y: -20,
			autoAlpha: 0,
			stagger: 0.1,
			clearProps: 'all',
			onStart() {
				$('.js-projects-sort').filter(':visible').removeClass('is-hidden');
			},
		});
});

// генерация выбранных фильтров в мобилке
function generateSelectFilters() {
	let wrap = '';

	for (let k of filters) {
		wrap += `<a class="js-filter-checked-remove menu__checked-link" data-target="${k}">
					<span>${k}</span>
					<svg class="menu__checked-link-icon"><use xlink:href="/images/sprites.svg#close"></use></svg>
				</a>`;
	}

	// обнуляем контейнер и кидаем новые элементы
	$('.menu__checked').html('').removeClass('is-hidden').append(wrap);
}

// получение отфильтрованных карточек
function getFilterItem() {
	let objActive = [];

	cards.each((i, e) => {
		let param = $(e).attr('data-filter');

		let k = filters.length;

		for (let j = 0; j < filters.length; j++) {
			if (param.indexOf(filters[j]) !== -1) {
				k--;
			}
		}

		if (k === 0) {
			objActive.push(e);
		}
	});

	for (let k of objActive) {
		new TimelineMax({
			onStart() {
				TweenMax.set($(k), {
					clearProps: 'all',
				});
				$(k).removeClass('is-hidden');
			},
		})
			.staggerFrom($(k), 0.4, {
				y: -20,
				stagger: 0.1,
				autoAlpha: 0,
				clearProps: 'all',
			});
	}
}

// делаем активную кнопку
// eslint-disable-next-line consistent-return
$('body').on('click', '.js-filter-sortable', (e) => {
	e.preventDefault();
	let $this = $(e.currentTarget);

	let dataParam = $this.attr('data-target');

	if ($(e.target).is('.js-filter-sortable-hide')) {
		return false;
	}

	if (dataParam !== 'all') {
		$('.projects__filtered').removeClass('is-empty').append(`
			<div class="projects__filtered__item" data-target="${dataParam}">
				<span>${dataParam}</span>
				<div>
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
						<polygon points="12,0.7 11.3,0 6,5.3 0.7,0 0,0.7 5.3,6 0,11.3 0.7,12 6,6.7 11.3,12 12,11.3 6.7,6"/>
					</svg>
				</div>
			</div>
		`);
	}

	// // если выбрано все года
	if (dataParam === 'all') {
		let years = [];

		$('.year').each((i, el) => {
			$(`[data-target="${$(el).attr('data-target')}"]`).removeClass('is-active');
			years.push($(el).attr('data-target'));
			$('.menu__checked').find(`[data-target="${$(el).attr('data-target')}"]`).remove();
		});

		for (let i = 0; i < years.length; i++) {
			for (let j = 0; j <= filters.length; j++) {
				if (filters[j] === years[i]) {
					filters.splice(j, 1);
				}
			}
		}

		sessionStorage.setItem('filters', filters);

		$('.js-filter-button').find('span').text(filters.length);

		if (!$('body').hasClass('main-page')) {
			location.href = '/';
		}

		new TimelineMax({
			onComplete() {
				$('.projects__item-container').addClass('is-hidden');
				getFilterItem();
			},
		})
			.staggerTo($('.projects__item-container'), 0.4, {
				y: -20,
				stagger: 0.1,
				autoAlpha: 0,
			});

		$(`.js-filter-sortable[data-target="${dataParam}"]`).addClass('is-active');

		return false;
	}

	if (!$this.hasClass('menu__link') && !$this.hasClass('projects__years-btn')) {
		filters.push(dataParam);

		$(`.js-filter-sortable[data-target="${dataParam}"]`).addClass('is-active');
	} else {
		if (filters.length > 0) {
			let count = null;

			for (let i = 0; i < filters.length; i++) {
				// ищем в массиве год, если есть, то записываем позицию
				if (dataParam.indexOf(filters[i]) !== -1) {
					count = i;
					break;
				}
			}
			// если позиция есть, то удаляем
			// если нет, то добавляем год в фильтр
			if (count !== null) {
				filters.splice(count, 1);
			} else {
				filters.push(dataParam);
			}
		} else {
			filters.push(dataParam);
		}

		if (!$('body').hasClass('main-page')) {
			if (filters.length > 0) {
				sessionStorage.setItem('filters', filters);
			}

			location.href = '/';
		}

		$('.allYear').removeClass('is-active');
		$(`.js-filter-sortable[data-target="${dataParam}"]`).toggleClass('is-active');
	}

	if (filters.length > 0) {
		sessionStorage.setItem('filters', filters);
	}

	$('.js-filter-button').find('span').text(filters.length);

	new TimelineMax({
		onComplete() {
			$('.projects__item-container').addClass('is-hidden');
			getFilterItem();
		},
	})
		.staggerTo($('.projects__item-container'), 0.4, {
			y: -20,
			stagger: 0.1,
			autoAlpha: 0,
		});
	generateSelectFilters();
});

// убираем активную кнопку
$('body').on('click', '.js-filter-sortable-hide', (e) => {
	$(e.currentTarget).parent().removeClass('is-active');

	for (let i = 0; i < filters.length; i++) {
		if ($(e.currentTarget).parent().attr('data-target').indexOf(filters[i]) !== -1) {
			filters.splice(i, 1);
			break;
		}
	}

	$(document).find(`.projects__filtered__item[data-target="${$(e.currentTarget).parent().attr('data-target')}"]`).remove();

	if ($(document).find('.projects__filtered__item').length === 0) {
		$('.projects__filtered').addClass('is-empty');
	}

	if (filters.length > 0) {
		sessionStorage.setItem('filters', filters);
	}

	$('.js-filter-button').find('span').text(filters.length);

	new TimelineMax({
		onComplete() {
			$('.projects__item-container').addClass('is-hidden');
			getFilterItem();
		},
	})
		.staggerTo($('.projects__item-container'), 0.4, {
			y: -20,
			stagger: 0.1,
			autoAlpha: 0,
		});
	generateSelectFilters();
});

$('body').on('click', '.projects__filtered__item div', (e) => {
	let data = $(e.currentTarget).parent().data('target');

	$(document).find(`.js-filter-sortable[data-target="${data}"]`).find('.js-filter-sortable-hide').trigger('click');
});

// убираем активную кнопку
$('body').on('click', '.js-filter-checked-remove', (e) => {
	for (let i = 0; i < filters.length; i++) {
		if ($(e.currentTarget).attr('data-target').indexOf(filters[i]) !== -1) {
			filters.splice(i, 1);
			break;
		}
	}

	$(e.currentTarget).remove();

	$(`.js-filter-sortable[data-target="${$(e.currentTarget).attr('data-target')}"]`).removeClass('is-active');

	if ($('.menu__checked').children().length === 0) {
		$('.menu__checked').addClass('is-hidden');
	}

	if (filters.length > 0) {
		sessionStorage.setItem('filters', filters);
	}

	$('.js-filter-button').find('span').text(filters.length);

	new TimelineMax({
		onComplete() {
			$('.projects__item-container').addClass('is-hidden');
			getFilterItem();
		},
	})
		.staggerTo($('.projects__item-container'), 0.4, {
			y: -20,
			stagger: 0.1,
			autoAlpha: 0,
		});
});

// очистка фильтров
$('.js-filter-sortable-clear').on('click', () => {
	filters = [];

	$('.js-filter-button').find('span').text(filters.length);

	$('.js-filter-sortable').removeClass('is-active');

	$('.allYear').addClass('is-active');

	sessionStorage.removeItem('filters');

	$('.menu__checked').removeClass('is-hidden').html('');

	new TimelineMax({
		onStart() {
			$('.js-projects-sort').removeClass('is-hidden');
		},
	})
		.staggerFrom($('.js-projects-sort'), 0.4, {
			y: -20,
			stagger: 0.1,
			autoAlpha: 0,
			clearProps: 'all',
		});
});

// ловим данные с sessionStorage при загрузке страницы
$(window).on('load', () => {
	if ($('body').hasClass('main-page')) {
		if (sessionStorage.getItem('filters')) {
			if (sessionStorage.getItem('filters').indexOf(',') !== -1) {
				filters = sessionStorage.getItem('filters').split(',');
			} else {
				filters.push(sessionStorage.getItem('filters'));
			}

			for (let i = 0; i < filters.length; i++) {
				$(`.js-filter-sortable[data-target="${filters[i]}"]`).addClass('is-active');

				if (filters[i] !== 'all') {
					$('.allYear').removeClass('is-active');
				}
			}

			// пересчитываем активные карточки
			$('.js-filter-button').find('span').text(filters.length);

			if ($(window).width() < 1024) {
				generateSelectFilters();
			}

			new TimelineMax({
				onStart() {
					$('.projects__item-container').addClass('is-hidden');
				},
				onComplete() {
					getFilterItem();
				},
			})
				.to($('.projects__item-container'), 0.2, {
					y: -20,
					autoAlpha: 0,
				});
		}
	}
});

setTimeout(() => {
	$(document).find('.js-filter-sortable.is-active').each((index, element) => {
		let dataParam = $(element).data('target');

		if (dataParam !== 'all') {
			$('.projects__filtered').removeClass('is-empty').append(`
				<div class="projects__filtered__item" data-target="${dataParam}">
					<span>${dataParam}</span>
					<div>
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
							<polygon points="12,0.7 11.3,0 6,5.3 0.7,0 0,0.7 5.3,6 0,11.3 0.7,12 6,6.7 11.3,12 12,11.3 6.7,6"/>
						</svg>
					</div>
				</div>
			`);
		}
	});
}, 100);
